<script setup lang="ts">
import {
  ref,
  provide,
  onMounted,
  onBeforeUnmount,
} from 'vue';
import {
  CdrContainer,
  CdrText,
} from '@rei/cedar';
import { recalculate } from '../../composables/useColumnsDisplay';
import CategoriesComponent from './CategoriesComponent.vue';
import { TMainState } from '../../models/types/ColumnsMainState';
import ColumnArticleComponent from './ColumnArticleComponent.vue';

const mainState = ref<TMainState>({
  helpCenter: '',
  mainCategory: '',
  secondaryCategory: '',
  articleId: '',
  adobeName: '',
});
const displayColumns = ref<boolean>(false);

const setState = (newState: Partial<TMainState>) => {
  mainState.value = {
    ...mainState.value,
    ...newState,
  };
};

provide('centerState', {
  setState, mainState,
});

// Visibility control. Consider abstracting this away.
let observer: MutationObserver | null = null;
const recalculateVisibility = () => { displayColumns.value = recalculate(); };
onMounted(() => {
  recalculateVisibility(); // initial state (full reloads and first paint)
  // react to browser navigations
  window.addEventListener('popstate', recalculateVisibility);
  window.addEventListener('hashchange', recalculateVisibility);
  // react to async article injection
  observer = new MutationObserver(recalculateVisibility);
  observer.observe(document.body, { childList: true, subtree: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('popstate', recalculateVisibility);
  window.removeEventListener('hashchange', recalculateVisibility);
  observer?.disconnect();
  observer = null;
});
</script>

<template>
  <section v-show="displayColumns">
    <CdrContainer class="help-centers-u__heading">
      <CdrText
        tag="h2"
        tabindex="0"
        class="help-center__heading-links"
      >
        Explore all help topics
      </CdrText>
    </CdrContainer>
    <div class="help-centers-u__columns">
      <CategoriesComponent />
      <ColumnArticleComponent />
    </div>
  </section>
</template>

<style lang="scss">
@import 'src/main/style/helpCenterColumnsUpdate.scss';
</style>
